export const CouponCodeSecrets: string[] = [
    'LOCAL-PICKUP'
];
